import UserHeader from "./UserHeader/UserHeader";
import Main from '../Elements/Main/Main';
import Footer from '../Elements/Footer/Footer';
function UserPage() {
    return (

        <>
            <UserHeader />
            <Main />
            <Footer />
        </>
    );
}

export default UserPage;